import Dropdown from "common/Dropdown/Dropdown.tsx";
import { ActionsDropdownIcon } from "common/styles.ts";
import React from "react";
import { useTheme } from "styled-components";
import { InvoiceAction } from "features/payouts/Invoices/hooks/useInvoice.tsx";
import RowActionsTrigger from "features/admin/NewLook/RowActionsTrigger";

interface InvoiceActionsProps {
  actions: InvoiceAction[];
  /** New look: a 40px trigger for phone cards. */
  largeTrigger?: boolean;
}

const InvoiceActions = ({ actions, largeTrigger }: InvoiceActionsProps) => {
  const { isNewLook } = useTheme();
  return (
    <Dropdown title="Actions" menu={{ items: actions }} trigger={["click"]}>
      {isNewLook ? (
        <RowActionsTrigger
          style={largeTrigger ? { width: 40, height: 40 } : undefined}
        />
      ) : (
        <ActionsDropdownIcon />
      )}
    </Dropdown>
  );
};

export default InvoiceActions;
